<template>
  <div class="favorite" @click="onFavoriteClicked">
    <span v-if="showFavoriteText" class="text">Favorite</span>
    <span v-if="favorite" class="af af-heart-full"></span>
    <span v-else class="af af-heart"></span>
  </div>
</template>

<script>
export default {
  name: 'Favorite',
  props: {
    favorite: {
      type: Boolean,
    },
    showFavoriteText: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    function onFavoriteClicked() {
      context.emit('favoriteClicked', !props.favorite);
    }

    return {
      onFavoriteClicked,
    };
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.favorite {
  display: flex;
  align-items: center;
  z-index: 2;
  background: var(--white);
  border-radius: var(--button-border-radius);
  padding: var(--space-1) var(--space-3);
  cursor: pointer;

  .text {
    margin-right: 4px;
    font-size: var(--font-size-14);
  }

  .af {
    font-size: 1.3em;
  }

  .af-heart-full {
    color: var(--coral);
  }

  @media (max-width: calc($tablet-breakpoint - 1px)) {
    .text {
      display: none;
    }

    &.round {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      justify-content: center;
      padding: var(--space-1);
    }
  }
}
</style>
